import {
  ROLE_ID_AGENTE_VENTAS,
  ROLE_ID_LIDER_VENTAS
} from '../constants/roleIds'

export interface ShouldShowOrderStateParams {
  estadoValue: string
  userRoleId: number
  mode: 'view' | 'edit' | 'create'
  paymentMethod?: string
  recogeEnBodega?: boolean
  currentStatus?: string
}

export function isSalesRoleWithoutStatusChoice(userRoleId: number): boolean {
  return userRoleId === ROLE_ID_AGENTE_VENTAS || userRoleId === ROLE_ID_LIDER_VENTAS
}

/**
 * Lista completa para todos los roles y modos.
 * El select está bloqueado; el estado lo define el método de pago o el valor del pedido.
 */
export function shouldShowOrderState(_params: ShouldShowOrderStateParams): boolean {
  return true
}

/**
 * Select de estado siempre bloqueado (create/edit/view), todos los roles.
 */
export function isOrderStatusSelectorDisabledForRole(
  _mode: 'view' | 'edit' | 'create',
  _fieldsLocked: boolean,
  _userRoleId: number
): boolean {
  return true
}
